import script from "./information.vue?vue&type=script&setup=true&lang=js"
export * from "./information.vue?vue&type=script&setup=true&lang=js"

import "./information.vue?vue&type=style&index=0&id=71a9b233&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a9b233"]])

export default __exports__